export interface CourierShipmentResponseModel {
  quotes: CourierQuote[];
  totalPackagingWeight: number;
  totalPackagingWeightDisplay: string;
  totalWeight: number;
  totalWeightDisplay: string;
  //packages: ShippingPackage[];
  packageCount: number;
  errorMessages: string[];
}

export interface CourierQuote {
  newsstandPackagingCost: number;
  totalCost: number;
  costWithoutTaxes: number;
  currency: string;
  taxes: number;
  courier: Couriers;
  serviceName: string;
  serviceType: string;
  serviceDescription: string;
  deliveryDate: Date;
  displayDeliveryDate: string;
  saturdayDelivery: boolean;
  costToPublisher: number;
  serviceDescriptionDisplay: string;
}

export enum Couriers {
  DHL = 1,
  MHI = 2,
  RoyalMail = 3,
  EVRI = 4,
  FedEx = 5
}